import Typography from '@precis-digital/kurama/Typography'
import { styled } from '@precis-digital/kurama/utils'

export const StyledTypographyTitleWithAvatars = styled(Typography)<{ $isTitleGreyed?: boolean }>(
  ({ $isTitleGreyed: isTitleGreyed, theme }) => ({
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    lineClamp: 1,
    ...(isTitleGreyed === true && {
      color: theme.tokens.foreground.main.disabled
    })
  })
)
